'use client';

import { V2Layout, RevealSection, useV2Lang, Eyebrow, Rule, HAIRLINE, PageHeader } from '../_layout';

const COPY = {
  CN: {
    kicker: '法律声明',
    title: '法律声明 / Impressum',
    lede: '根据 § 5 TMG 和 § 55 RStV 提供的信息。',
    sec1: '机构信息',
    sec2: '联系方式',
    sec3: '内容负责人',
    sec4: '法律状态',
    sec5: '免责声明',
    nameLabel: '名称',
    nameValue: 'PathIN e.V.',
    addrLabel: '地址',
    addrValue: 'Arabellastraße 5, Apt. 416\n81925 München\nDeutschland',
    repLabel: '代表人',
    repValue: 'Ming Huang（会长 · Vereinsvorsitzender）\nBailan He（副会长）\nKe Ma（秘书）',
    emailLabel: '邮箱',
    emailValue: 'pathin@pathin.eu',
    statusValue: '已注册公益协会 (Eingetragener gemeinnütziger Verein)',
    statusSub: '注册号待补充。德国税务部门已认定为公益机构。',
    disclaimer: '本网站内容经过精心制作。但我们不能保证其准确性、完整性和及时性。作为服务提供商，我们根据德国一般法律对本网站内容负责。但我们没有义务监控传输或存储的第三方信息，也没有义务调查可能表明非法活动的情况。',
  },
  EN: {
    kicker: 'Legal Notice',
    title: 'Impressum',
    lede: 'Information in accordance with § 5 TMG and § 55 para. 2 RStV.',
    sec1: 'Organization',
    sec2: 'Contact',
    sec3: 'Responsible for content',
    sec4: 'Legal status',
    sec5: 'Disclaimer',
    nameLabel: 'Name', nameValue: 'PathIN e.V.',
    addrLabel: 'Address',
    addrValue: 'Arabellastraße 5, Apt. 416\n81925 München\nGermany',
    repLabel: 'Represented by',
    repValue: 'Ming Huang (Vereinsvorsitzender / President)\nBailan He (Vice President)\nKe Ma (Secretary)',
    emailLabel: 'Email', emailValue: 'pathin@pathin.eu',
    statusValue: 'Registered nonprofit association (Eingetragener gemeinnütziger Verein)',
    statusSub: 'Registration number to be provided. Recognized as a nonprofit by the German tax authorities.',
    disclaimer: "The contents of this website were created with the greatest care. However, we cannot guarantee the accuracy, completeness, and timeliness of the content. As a service provider, we are responsible for our own content on these pages in accordance with general law. We are not, however, obliged to monitor transmitted or stored third-party information or to investigate circumstances that might indicate illegal activity.",
  },
  DE: {
    kicker: 'Impressum',
    title: 'Impressum',
    lede: 'Angaben gemäß § 5 TMG und § 55 Abs. 2 RStV.',
    sec1: 'Vereinsangaben',
    sec2: 'Kontakt',
    sec3: 'Verantwortlich für den Inhalt',
    sec4: 'Rechtlicher Status',
    sec5: 'Haftungsausschluss',
    nameLabel: 'Name', nameValue: 'PathIN e.V.',
    addrLabel: 'Anschrift',
    addrValue: 'Arabellastraße 5, Apt. 416\n81925 München\nDeutschland',
    repLabel: 'Vertreten durch',
    repValue: 'Ming Huang (Vereinsvorsitzender)\nBailan He (Vize-Vorsitzender)\nKe Ma (Schriftführer)',
    emailLabel: 'E-Mail', emailValue: 'pathin@pathin.eu',
    statusValue: 'Eingetragener gemeinnütziger Verein',
    statusSub: 'Registernummer wird ergänzt. Anerkannt als gemeinnützig durch das zuständige Finanzamt.',
    disclaimer: 'Die Inhalte dieser Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.',
  },
};

export default function V2Impressum() {
  const lang = useV2Lang();
  const t = COPY[lang];
  const rows: Array<[string, string, string]> = [
    [t.sec1, t.nameLabel, t.nameValue],
    ['', t.addrLabel, t.addrValue],
    [t.sec2, t.emailLabel, t.emailValue],
    [t.sec3, t.repLabel, t.repValue],
    [t.sec4, '', t.statusValue],
  ];
  return (
    <V2Layout hideFooterContact>
      <PageHeader kicker={t.kicker} title={t.title} lede={t.lede} />
      <Rule />
      <RevealSection className="px-6 md:px-10 py-16">
        <div className="mx-auto max-w-[1100px]">
          <dl className="border-t" style={{ borderColor: HAIRLINE }}>
            {rows.map(([section, label, value], idx) => (
              <div key={idx} className="grid grid-cols-12 gap-4 py-6 border-b items-start" style={{ borderColor: HAIRLINE }}>
                <dt className="col-span-12 md:col-span-3 font-mono text-[11px] uppercase tracking-[0.15em] text-white/65">{section}</dt>
                <div className="col-span-12 md:col-span-3 text-[13px] text-white/75">{label}</div>
                <dd className="col-span-12 md:col-span-6 text-[15px] text-white whitespace-pre-line">{value}</dd>
              </div>
            ))}
          </dl>
          <p className="mt-4 text-[13px] text-white/50">{t.statusSub}</p>
        </div>
      </RevealSection>
      <Rule />
      <RevealSection className="px-6 md:px-10 py-16">
        <div className="mx-auto max-w-[800px]">
          <Eyebrow>{t.sec5}</Eyebrow>
          <p className="mt-6 text-[15px] leading-[1.7] text-white/80">{t.disclaimer}</p>
        </div>
      </RevealSection>
      <Rule />
    </V2Layout>
  );
}
